/** Normalize admin slider links (with or without protocol). */
export function normalizeSliderHref(href: string): string {
  const trimmed = href.trim()
  if (!trimmed) return ''
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  if (trimmed.startsWith('//')) return `https:${trimmed}`
  if (trimmed.startsWith('/')) return trimmed
  return `https://${trimmed.replace(/^\/+/, '')}`
}
